import { useId, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { map } from './core/MapView';

/**
 * Lucide icon paths para cada tipo de evento
 * Paths extraídos de https://lucide.dev/icons
 */
const LUCIDE_PATHS = {
  // LogIn - entrada
  logIn: 'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4 M10 17l5-5-5-5 M15 12H3',
  // LogOut - saída
  logOut: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9',
  // AlertTriangle - alarme
  alertTriangle: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z M12 9v4 M12 17h.01',
  // Gauge - velocidade
  gauge: 'M12 16v-4 M12 8h.01 M12 2a10 10 0 1 0 10 10 M17.5 6.5L12 12',
  // Power - ignição ligada
  power: 'M18.36 6.64a9 9 0 1 1-12.73 0 M12 2v10',
  // PowerOff - ignição desligada
  powerOff: 'M18.36 6.64A9 9 0 0 1 20.77 14.5 M6.16 6.16a9 9 0 1 0 12.68 12.68 M12 2v4 M2 2l20 20',
  // Wrench - manutenção
  wrench: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z',
  // User - motorista
  user: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2 M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z',
  // Wifi - online
  wifi: 'M5 12.55a11 11 0 0 1 14.08 0 M1.42 9a16 16 0 0 1 21.16 0 M8.53 16.11a6 6 0 0 1 6.95 0 M12 20h.01',
  // WifiOff - offline
  wifiOff: 'M1 1l22 22 M16.72 11.06A10.94 10.94 0 0 1 19 12.55 M5 12.55a10.94 10.94 0 0 1 5.17-2.39 M10.71 5.05A16 16 0 0 1 22.58 9 M1.42 9a15.91 15.91 0 0 1 4.7-2.88 M8.53 16.11a6 6 0 0 1 6.95 0 M12 20h.01',
  // CircleHelp - desconhecido
  circleHelp: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3 M12 17h.01',
  // CirclePause - inativo
  circlePause: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M10 15V9 M14 15V9',
  // Car - movendo
  car: 'M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.6-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2 M7 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4z M17 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
  // CircleParking - parado
  circleParking: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M9 17V7h4a3 3 0 0 1 0 6H9',
  // Fuel - combustível
  fuel: 'M3 22V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v17 M3 10h10 M13 22H3 M14 5v3a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v7a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 4',
  // Terminal - comando
  terminal: 'M4 17l6-6-6-6 M12 19h8',
  // Camera - mídia
  camera: 'M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z M12 13a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  // Bell - notificação genérica
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9 M10.3 21a1.94 1.94 0 0 0 3.4 0',
  // MapPin - localização genérica
  mapPin: 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
};

/**
 * Configuração de ícones para cada tipo de evento
 * Usando Lucide icons para melhor visualização
 */
const EVENT_ICONS = {
  // Geocercas
  geofenceEnter: { icon: 'logIn', color: '#4CAF50', label: 'Entrada', labelKey: 'eventGeofenceEnter' },
  geofenceExit: { icon: 'logOut', color: '#F44336', label: 'Saída', labelKey: 'eventGeofenceExit' },

  // Alarmes
  alarm: { icon: 'alertTriangle', color: '#FF5722', label: 'Alarme', labelKey: 'eventAlarm' },

  // Velocidade
  deviceOverspeed: { icon: 'gauge', color: '#FF9800', label: 'Velocidade', labelKey: 'eventDeviceOverspeed' },

  // Ignição
  ignitionOn: { icon: 'power', color: '#4CAF50', label: 'Ignição Ligada', labelKey: 'eventIgnitionOn' },
  ignitionOff: { icon: 'powerOff', color: '#9E9E9E', label: 'Ignição Desligada', labelKey: 'eventIgnitionOff' },

  // Falta de Pagamento
  overduePaymentIgnition: { icon: 'alertTriangle', color: '#D32F2F', label: 'Falta de Pagamento', labelKey: 'eventOverduePaymentIgnition' },

  // Manutenção
  maintenance: { icon: 'wrench', color: '#9C27B0', label: 'Manutenção', labelKey: 'eventMaintenance' },

  // Motorista
  driverChanged: { icon: 'user', color: '#2196F3', label: 'Motorista', labelKey: 'eventDriverChanged' },

  // Dispositivo
  deviceOnline: { icon: 'wifi', color: '#4CAF50', label: 'Online', labelKey: 'eventDeviceOnline' },
  deviceOffline: { icon: 'wifiOff', color: '#F44336', label: 'Offline', labelKey: 'eventDeviceOffline' },
  deviceUnknown: { icon: 'circleHelp', color: '#9E9E9E', label: 'Desconhecido', labelKey: 'eventDeviceUnknown' },
  deviceInactive: { icon: 'circlePause', color: '#607D8B', label: 'Inativo', labelKey: 'eventDeviceInactive' },
  deviceMoving: { icon: 'car', color: '#2196F3', label: 'Movendo', labelKey: 'eventDeviceMoving' },
  deviceStopped: { icon: 'circleParking', color: '#FF9800', label: 'Parado', labelKey: 'eventDeviceStopped' },

  // Combustível
  deviceFuelDrop: { icon: 'fuel', color: '#F44336', label: 'Queda Combustível', labelKey: 'eventDeviceFuelDrop' },
  deviceFuelIncrease: { icon: 'fuel', color: '#4CAF50', label: 'Abastecimento', labelKey: 'eventDeviceFuelIncrease' },

  // Comandos
  commandResult: { icon: 'terminal', color: '#673AB7', label: 'Comando', labelKey: 'eventCommandResult' },

  // Mídia
  media: { icon: 'camera', color: '#00BCD4', label: 'Mídia', labelKey: 'eventMedia' },

  // Default
  default: { icon: 'bell', color: '#607D8B', label: 'Evento', labelKey: 'sharedNotification' },
};

/**
 * Cria um elemento SVG para o marcador de evento com ícone Lucide
 * Pin colorido com ícone branco no centro
 */
const createEventMarkerSvg = (eventType, customColor) => {
  const iconConfig = EVENT_ICONS[eventType] || EVENT_ICONS.default;
  const markerColor = customColor || iconConfig.color;
  const iconPath = LUCIDE_PATHS[iconConfig.icon] || LUCIDE_PATHS.bell;

  // SVG com pin drop e ícone Lucide branco interno
  // Separar múltiplos paths (Lucide usa múltiplos comandos M separados por espaço)
  const pathCommands = iconPath.split(' M').map((p, i) => i === 0 ? p : `M${p}`);
  const pathElements = pathCommands.map((d) =>
    `<path d="${d}" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>`
  ).join('');

  // Ícone 24x24 com scale 0.85 = 20.4px, centralizado no círculo do pin (centro em 18,16)
  // translate = centro - (tamanho_icone_escalado / 2) = (18 - 10.2, 16 - 10.2) ≈ (8, 6)
  return `
    <svg width="36" height="48" viewBox="0 0 36 48" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="shadow-${eventType}" x="-30%" y="-10%" width="160%" height="130%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#000" flood-opacity="0.45"/>
        </filter>
      </defs>
      <!-- Pin shape -->
      <path d="M18 0C8.06 0 0 8.06 0 18c0 14 18 30 18 30s18-16 18-30C36 8.06 27.94 0 18 0z"
            fill="${markerColor}" filter="url(#shadow-${eventType})" stroke="#fff" stroke-width="2"/>
      <!-- Ícone Lucide branco centralizado e maior -->
      <g transform="translate(8, 5) scale(0.85)">
        ${pathElements}
      </g>
    </svg>
  `;
};

/**
 * Cache de imagens de marcadores para evitar recriação
 * Versão incrementada para invalidar cache quando SVG muda
 */
const MARKER_VERSION = 5;

/**
 * Converte SVG string para imagem base64 para uso no MapLibre
 */
const svgToDataUrl = (svgString) => {
  const encoded = encodeURIComponent(svgString);
  return `data:image/svg+xml,${encoded}`;
};

/**
 * Carrega imagem do marcador no mapa (retorna Promise)
 */
const loadMarkerImage = (mapInstance, eventType) => {
  return new Promise((resolve) => {
    const imageId = `event-marker-v${MARKER_VERSION}-${eventType}`;

    // Retorna se já existe no mapa
    if (mapInstance.hasImage(imageId)) {
      resolve(imageId);
      return;
    }

    // Cria novo marcador SVG
    const svg = createEventMarkerSvg(eventType);
    const img = new Image();
    img.src = svgToDataUrl(svg);

    img.onload = () => {
      if (!mapInstance.hasImage(imageId)) {
        mapInstance.addImage(imageId, img, { sdf: false });
      }
      resolve(imageId);
    };

    img.onerror = () => {
      console.error(`Failed to load marker image for event type: ${eventType}`);
      resolve(imageId); // Resolve anyway to not block
    };
  });
};

/**
 * MapEventMarkers - Renderiza marcadores de eventos no mapa
 *
 * Props:
 * - events: Array de eventos com positionId
 * - positions: Objeto mapeando positionId -> position
 * - geofences: Objeto de geocercas
 * - onClick: Callback quando clica em um evento
 * - showGeofences: Se deve desenhar geocercas dos eventos
 */
const MapEventMarkers = ({
  events = [],
  positions = {},
  geofences = {},
  onClick,
  showGeofences = true,
}) => {
  const id = useId();
  const theme = useTheme();

  useEffect(() => {
    if (!map) return;

    const sourceId = `events-source-${id}`;
    const layerId = `events-layer-${id}`;
    const geofenceSourceId = `events-geofence-source-${id}`;
    const geofenceLayerId = `events-geofence-layer-${id}`;
    const geofenceOutlineLayerId = `events-geofence-outline-${id}`;

    let cancelled = false;

    // Função async para carregar imagens e depois adicionar layers
    const setupMapLayers = async () => {
      // Carregar imagens dos marcadores para cada tipo de evento usado
      const eventTypes = new Set(events.map((e) => e.type || 'default'));
      eventTypes.add('default'); // Garantir que o default está carregado

      // Aguardar carregamento de todas as imagens
      await Promise.all(
        Array.from(eventTypes).map((type) => loadMarkerImage(map, type))
      );

      // Verificar se o efeito foi cancelado durante o carregamento
      if (cancelled) return;

      // Preparar features dos eventos
      const eventFeatures = events
        .filter((event) => {
          const pos = positions[event.positionId];
          return pos && pos.latitude && pos.longitude;
        })
        .map((event) => {
          const pos = positions[event.positionId];
          const iconConfig = EVENT_ICONS[event.type] || EVENT_ICONS.default;
          const eventType = event.type || 'default';
          return {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [pos.longitude, pos.latitude],
            },
            properties: {
              id: event.id,
              type: eventType,
              iconImage: `event-marker-v${MARKER_VERSION}-${EVENT_ICONS[eventType] ? eventType : 'default'}`,
              color: iconConfig.color,
              label: iconConfig.label,
              labelKey: iconConfig.labelKey,
              deviceId: event.deviceId,
              eventTime: event.eventTime,
              geofenceId: event.geofenceId,
              attributes: JSON.stringify(event.attributes || {}),
            },
          };
        });

      // Preparar features das geocercas
      const geofenceFeatures = [];
      if (showGeofences) {
        const usedGeofenceIds = new Set(
          events.filter((e) => e.geofenceId).map((e) => e.geofenceId)
        );

        usedGeofenceIds.forEach((geoId) => {
          const geofence = geofences[geoId];
          if (geofence && geofence.area) {
            const area = geofence.area;

            if (area.startsWith('CIRCLE')) {
              // CIRCLE (lat lon, radius)
              const match = area.match(/CIRCLE\s*\(\s*([\d.-]+)\s+([\d.-]+),\s*([\d.]+)\s*\)/i);
              if (match) {
                const lat = parseFloat(match[1]);
                const lon = parseFloat(match[2]);
                const radius = parseFloat(match[3]);

                // Criar círculo aproximado com polígono
                const points = 64;
                const coords = [];
                for (let i = 0; i <= points; i++) {
                  const angle = (i / points) * 2 * Math.PI;
                  const dx = (radius / 111320) * Math.cos(angle);
                  const dy = (radius / (111320 * Math.cos((lat * Math.PI) / 180))) * Math.sin(angle);
                  coords.push([lon + dy, lat + dx]);
                }

                geofenceFeatures.push({
                  type: 'Feature',
                  geometry: {
                    type: 'Polygon',
                    coordinates: [coords],
                  },
                  properties: {
                    id: geoId,
                    name: geofence.name,
                  },
                });
              }
            } else if (area.startsWith('POLYGON')) {
              // POLYGON ((lon lat, lon lat, ...))
              const match = area.match(/POLYGON\s*\(\((.*?)\)\)/i);
              if (match) {
                const coordsStr = match[1];
                const coords = coordsStr.split(',').map((pair) => {
                  const [lat, lon] = pair.trim().split(/\s+/).map(parseFloat);
                  return [lon, lat];
                });

                if (coords.length > 2) {
                  // Fechar polígono se necessário
                  if (coords[0][0] !== coords[coords.length - 1][0] ||
                      coords[0][1] !== coords[coords.length - 1][1]) {
                    coords.push(coords[0]);
                  }

                  geofenceFeatures.push({
                    type: 'Feature',
                    geometry: {
                      type: 'Polygon',
                      coordinates: [coords],
                    },
                    properties: {
                      id: geoId,
                      name: geofence.name,
                    },
                  });
                }
              }
            } else if (area.startsWith('LINESTRING')) {
              // LINESTRING (lon lat, lon lat, ...)
              const match = area.match(/LINESTRING\s*\((.*?)\)/i);
              if (match) {
                const coordsStr = match[1];
                const coords = coordsStr.split(',').map((pair) => {
                  const [lat, lon] = pair.trim().split(/\s+/).map(parseFloat);
                  return [lon, lat];
                });

                geofenceFeatures.push({
                  type: 'Feature',
                  geometry: {
                    type: 'LineString',
                    coordinates: coords,
                  },
                  properties: {
                    id: geoId,
                    name: geofence.name,
                  },
                });
              }
            }
          }
        });
      }

      // Adicionar source e layer de geocercas
      if (geofenceFeatures.length > 0) {
        map.addSource(geofenceSourceId, {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: geofenceFeatures,
          },
        });

        // Layer de preenchimento
        map.addLayer({
          id: geofenceLayerId,
          type: 'fill',
          source: geofenceSourceId,
          paint: {
            'fill-color': theme.palette.primary.main,
            'fill-opacity': 0.15,
          },
        });

        // Layer de contorno
        map.addLayer({
          id: geofenceOutlineLayerId,
          type: 'line',
          source: geofenceSourceId,
          paint: {
            'line-color': theme.palette.primary.main,
            'line-width': 2,
            'line-opacity': 0.7,
          },
        });
      }

      // Adicionar source e layer de eventos
      map.addSource(sourceId, {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: eventFeatures,
        },
      });

      // Usar symbol layer com ícones personalizados
      map.addLayer({
        id: layerId,
        type: 'symbol',
        source: sourceId,
        layout: {
          'icon-image': ['get', 'iconImage'],
          'icon-size': 1,
          'icon-allow-overlap': true,
          'icon-anchor': 'bottom',
          'icon-offset': [0, 0],
        },
      });

      // Adicionar interatividade
      map.on('mouseenter', layerId, () => {
        map.getCanvas().style.cursor = 'pointer';
      });

      map.on('mouseleave', layerId, () => {
        map.getCanvas().style.cursor = '';
      });

      if (onClick) {
        map.on('click', layerId, (e) => {
          const feature = e.features[0];
          if (feature) {
            const eventId = feature.properties.id;
            const event = events.find((ev) => ev.id === eventId);
            if (event) {
              onClick(event, positions[event.positionId]);
            }
          }
        });
      }
    };

    // Executar setup
    setupMapLayers();

    // Cleanup
    return () => {
      cancelled = true;
      if (map.getLayer(layerId)) map.removeLayer(layerId);
      if (map.getSource(sourceId)) map.removeSource(sourceId);
      if (map.getLayer(geofenceOutlineLayerId)) map.removeLayer(geofenceOutlineLayerId);
      if (map.getLayer(geofenceLayerId)) map.removeLayer(geofenceLayerId);
      if (map.getSource(geofenceSourceId)) map.removeSource(geofenceSourceId);
    };
  }, [events, positions, geofences, showGeofences, onClick, id, theme]);

  return null;
};

export { EVENT_ICONS };
export default MapEventMarkers;
